import { useTranslations } from "use-intl";

import { CircularProgress } from "@/components/CircularProgress/CircularProgress";

type Props = {
  count: number;
};

export const OrdersInCreationCard = ({ count }: Props) => {
  const t = useTranslations();

  return (
    <div className="section-card mb-2 flex flex-row items-center gap-2 rounded-3xl">
      <CircularProgress size={20} />
      <span className="text-sm">
        {t("reservations.ordersInTheProcessOfCreation", { count })}
      </span>
    </div>
  );
};
